import { render, staticRenderFns } from "./NotificationItem.vue?vue&type=template&id=23574e82"
import script from "./NotificationItem.vue?vue&type=script&lang=ts"
export * from "./NotificationItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23574e82')) {
      api.createRecord('23574e82', component.options)
    } else {
      api.reload('23574e82', component.options)
    }
    module.hot.accept("./NotificationItem.vue?vue&type=template&id=23574e82", function () {
      api.rerender('23574e82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/notification/NotificationItem.vue"
export default component.exports